export default {"src":"/_next/static/media/facebook.7e01a8bb.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};